import type { AiQueueAction, AiQueueRecord, AiQueueStatus } from "@cv-screener/shared";

const statuses: AiQueueStatus[] = ["Processing", "Pending", "Failed", "Completed", "Completed", "Failed", "Completed", "Completed", "Completed", "Completed", "Completed", "Completed"];
const actions: AiQueueAction[] = ["rescore-candidate", "process-incoming-cv", "process-incoming-cv", "generate-job-markdown", "reextract-cv-profile", "bulk-rescore"];

export const demoAiQueue: AiQueueRecord[] = statuses.map((status, index) => {
  const dayOffset = index % 7;
  const createdAt = new Date(Date.UTC(2026, 7, 17 - dayOffset, 8, 54 - dayOffset * 8)).toISOString();
  const finished = status === "Completed" || status === "Failed";
  const action = actions[index % actions.length]!;
  const requestId = `10000000-0000-4000-8000-${String(index + 1).padStart(12, "0")}`;
  const jobId = ["QS-2026-01", "PM-2026-03", "DD-2026-02"][index % 3]!;
  const applicationId = action === "generate-job-markdown" ? "" : `APP-${String(index + 1).padStart(12, "A").slice(-12)}`;
  const responseText = status === "Completed"
    ? JSON.stringify({ candidate: { name: "Demo Candidate" }, scoring: { overallScore: 78, recommendation: "Potential Match" }, note: "Synthetic response for interface review." }, null, 2)
    : status === "Failed" ? JSON.stringify({ error: "The model response ended before a complete JSON object was returned." }, null, 2) : "";
  return {
    schemaVersion: "1.0",
    requestId,
    region: "HK",
    action,
    status,
    sourceSubmittedAt: action === "process-incoming-cv" ? new Date(Date.parse(createdAt) - (index + 2) * 86_400_000).toISOString() : createdAt,
    jobId,
    applicationId,
    initiatedBy: index % 4 === 1 ? "scheduled-worker" : "admin@example.com",
    provider: "Gemini",
    model: "gemini-demo-model",
    createdAt,
    startedAt: status === "Pending" ? null : new Date(Date.parse(createdAt) + 1_200).toISOString(),
    completedAt: finished ? new Date(Date.parse(createdAt) + 18_500 + index * 510).toISOString() : null,
    updatedAt: finished ? new Date(Date.parse(createdAt) + 18_500 + index * 510).toISOString() : createdAt,
    durationMs: finished ? 18_500 + index * 510 : null,
    inputTokens: finished ? 4_180 + index * 97 : null,
    outputTokens: finished ? 1_040 + index * 41 : null,
    totalTokens: finished ? 5_220 + index * 138 : null,
    cachedInputTokens: finished ? index * 32 : null,
    requestSnapshot: {
      systemInstruction: "Synthetic system instruction: extract job-related evidence and return valid JSON only.",
      systemInstructionTruncated: false,
      parts: [
        { kind: "text", label: "Assessment task", text: `Synthetic request for ${jobId}. Assess the supplied demo CV against the demo job requirements.`, truncated: false },
        { kind: "document", label: "CV", mimeType: "application/pdf", sizeBytes: 184_320 + index * 2_048, sha256: String(index + 1).padStart(64, "a").slice(-64) },
      ],
    },
    responseText,
    responseTruncated: false,
    errorCode: status === "Failed" ? (index % 2 ? "GEMINI_RATE_LIMITED" : "INVALID_GEMINI_OUTPUT") : "",
    errorReason: status === "Failed" ? (index % 2 ? "Gemini could not complete this request" : "Gemini output did not match the required application schema") : "",
  };
});
